import { useCallback } from "react";
import type { AgentDocumentSearchScopeDto, AgentDocumentSearchSessionDto } from "../../autogen/bff-api";
import { useCreateAgentDocumentSearchSessionMutation } from "../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";

export const useAgentSession = () => {
  const [createSession] = useCreateAgentDocumentSearchSessionMutation();
  const authState = useLoggedInWithOrgContextState();

  const createDocSearchSession = useCallback(
    async (scope: AgentDocumentSearchScopeDto | null): Promise<AgentDocumentSearchSessionDto> =>
      createSession({
        organizationId: authState.selectedOrg.id,
        personId: authState.me.id,
        createAgentDocumentSearchSessionRequest: { scope },
      }).unwrap(),
    [createSession, authState.selectedOrg.id, authState.me.id],
  );

  return { createDocSearchSession };
};
